export default {"src":"/_next/static/media/lock-image.6651484b.svg","height":520,"width":520,"blurWidth":0,"blurHeight":0};